<template>
  <div class="loginView">
    <HeadBar title="测试cookie" />
    <div class="loginBox">
      <van-button round block type="info" @click="getCookie" class="font-24">点击获取cookie</van-button>

      <van-button round block type="info" @click="delAllCookie" class="font-24">删所有cookie</van-button>
    </div>
  </div>
</template>

<script>
  import HeadBar from "@/components/HeadBar.vue";
  import { fetchHttp, delAllCookie } from "@/util/fn.js";
  import { Toast, Button } from "vant";
  export default {
    name: "loginView",
    components: {
      HeadBar,
      [Button.name]: Button,
    },
    data() {
      return {};
    },
    computed: {},
    mounted() { },
    methods: {

      getCookie() {
        let cookieStr = JSON.stringify(Cookies.getJSON())
        this.copy(cookieStr);
        alert(cookieStr);
      },

      copy(str) {
        let save = function (e) {
          e.clipboardData.setData("text/plain", str); //下面会说到clipboardData对象
          e.preventDefault(); //阻止默认行为
        };
        document.addEventListener("copy", save);
        document.execCommand("copy"); //使文档处于可编辑状态，否则无效
      },

      delAllCookie() {
        delAllCookie();
      },
    },
  };
</script>
<style scope lang="less">
  .loginBox {
    background-color: #ffffff;
    text-align: center;
    height: calc(100vh - 50px);
  }

  .van-cell--clickable {
    line-height: 30px;
  }

  .userMobile {
    margin-top: 50px;
  }

  .topBox {
    position: relative;
    width: 100px;
    height: 100px;
    left: 50%;
    margin-left: -50px;
  }

  .userName {
    background: rgba(0, 0, 0, 0.5);
    width: 100px;
    display: inline-block;
    position: absolute;
    bottom: -30px;
    left: 0;
  }

  .headInfo {
    width: 100vw;
    height: 250px;
    background: linear-gradient(157deg, #5b6f95 0, #35425f 100%);
    text-align: center;
    color: #fff;
  }

  .itemList {
    width: 100%;
  }

  .loginView {
    width: 100vw;
    height: calc(100vh - 50px);
    background-color: #f8f8f8;
    padding-bottom: 50px;
    margin-top: -16px;
  }

  .logoImg {
    margin: 50px 0;
  }

  .loginForm .van-cell {
    font-size: 16px;
  }

  .font-24 {
    font-size: 20px;
    margin-top: 50px;
  }
</style>